export function getAmountWithCurrency(amount: string, currency: string, locale: string): string {
    return formatAmount(amount, currency, 3, locale);
}

export function getTotalAmountWithCurrency(amount: string, currency: string, locale: string): string {
    return formatAmount(amount, currency, 2, locale);
}

function formatAmount(amount: string, currency: string, fractionDigits: number, locale: string): string {
    if (isBlank(amount)) {
        return '';
    }
    if (isBlank(currency)) {
        currency = 'EUR';
    }
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits
    }).format(parseFloat(amount));
}

export function isBlank(str: string) {
    return !str || /^\s*$/.test(str);
}


export function getFormattedDate(date: Date, locale: string): string {
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour12: false
    };

    if (date) {
        try {
            let newDate = new Date(date);
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(',', '');
        } catch (error) {
            return '';
        }
    } else {
        return '';
    }
}
